var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileTxt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 46,
    viewBox: "0 0 36 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#E1E1E3",
    strokeWidth: 2,
    d: "M7.692 1c-2.288 0-3.204.177-4.15.683a4.452 4.452 0 0 0-1.859 1.858C1.177 4.488 1 5.404 1 7.691v30.617c0 2.288.177 3.204.683 4.15a4.452 4.452 0 0 0 1.858 1.859c.947.506 1.863.683 4.15.683h20.617c2.288 0 3.204-.177 4.15-.683a4.452 4.452 0 0 0 1.859-1.858c.506-.947.683-1.863.683-4.15V14.501c0-1.387-.04-1.902-.168-2.456a4.224 4.224 0 0 0-.552-1.332c-.302-.482-.638-.874-1.62-1.854l-5.538-5.528c-.98-.979-1.373-1.314-1.854-1.615a4.224 4.224 0 0 0-1.33-.55C23.387 1.04 22.872 1 21.487 1H7.692z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9AA2",
    d: "M31 35v1H5v-1h26zm0-3v1H5v-1h26zm0-3v1H5v-1h26zm0-3v1H5v-1h26zm0-3v1H5v-1h26zm0-3v1H5v-1h26zm0-3v1H5v-1h26zm-4-3v1H5v-1h22zm-4-3v1H5v-1h18zm-3-3v1H5V8h15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTxt);
export default __webpack_public_path__ + "static/media/file-txt.069282d3.svg";
export { ForwardRef as ReactComponent };